import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import WhatsAppButton from '../components/WhatsAppButton';
import ARLiveChat from '../components/ARLiveChat';
import CartFlyParticle from '../components/CartFlyParticle';
import { useFacebookPixel } from '../hooks/useFacebookPixel';

const StorefrontLayout: React.FC = () => {
  // Track PageView on every route change
  useFacebookPixel();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppButton />
      <ARLiveChat />
      {/* Cart fly-to-cart animation overlay */}
      <CartFlyParticle />
    </div>
  );
};

export default StorefrontLayout;
